 /* Правила формирования мета данных 
  1 Имя компонента должно быть уникальным
  2  Id компонента должны быть уникальными
 */
export const meta = {
    columnCount: 6,
    rowCount: 3,
    components: [
        {
            id: 1,
            name: 'hs23-view',
            parentComponent: null,
            parentName: '',
            column: 3,
            row: 1,
            selectUrl: 'core./core/hs-23-select/get',
            save: 'core./core/hs-23-save/set',
        },
        {
            id: 2,
            name: 'ai-test1',
            parentName: 'hs23-view',
            parentComponent: 1,
            selectUrl: 'demo./demo/ai-test1/select',
            save: 'demo./demo/update_data/grid/put',
        },
        {
            id: 3,
            name: 'edit-gridpopup',
            parentName: 'ai-test1',
            parentComponent: 2,
            selectUrl: 'demo./demo/edit-gridpopup-select/get',
            save: 'demo./demo/edit-gridpopup-save/set',
        },
    ],
};
